import 'es6-promise/auto';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas as pro } from '@fortawesome/pro-solid-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Element from 'element-ui';
import VueAnalytics from 'vue-analytics';
import locale from 'element-ui/lib/locale/lang/fr';
import './assets/scss/element-variables.scss';

import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';


library.add(pro);
library.add(fal);
Vue.component('font-awesome-icon', FontAwesomeIcon);

if (process.env.VUE_APP_BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginVue()],
  });
  Bugsnag.getPlugin('vue')
    .installVueErrorHandler(Vue);
}

if (process.env.VUE_APP_GOOGLE_ANALYTICS_ID) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
    router,
  });
}

Vue.use(Element, { locale });

Vue.config.productionTip = false;
const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');

if (window.Cypress) {
  window.app = app;
}
